import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { store } from './modules/store';
import App from './App';
import router from './modules/router/config';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import jQuery from 'jquery';
import { CONSTANTS } from '@/constants/guide';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import "vue-advanced-cropper/dist/style.css";
import { VTooltip} from 'floating-vue';
import 'floating-vue/dist/style.css';
import VueUploadComponent from 'vue-upload-component';

String.prototype.capitalize = function () {
  return this.charAt(0).toUpperCase() + this.slice(1);
};

window.jQuery = jQuery;

Vue.prototype.CONSTANTS = CONSTANTS;

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueSweetalert2);
Vue.directive('tooltip', VTooltip);
Vue.component('file-upload', VueUploadComponent);

Vue.config.productionTip = process.env.VUE_APP_ENV === 'production';

sync(store, router);
/**
 * enable devtools before creating the app
 * @link https://github.com/vuejs/vue-devtools#force-enable-the-devtools
 */
Vue.config.devtools =
  process.env.VUE_APP_ENV === 'local' || process.env.VUE_APP_ENV === 'staging';

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = (event) => {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

new Vue({
  store,
  router,
  render: (h) => h(App),
}).$mount('#app');
// After you create app
if (
  process.env.VUE_APP_ENV === 'local' ||
  process.env.VUE_APP_ENV === 'staging'
) {
  try {
    window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app.constructor;
  } catch (err) {
    console.error('please install vue devtools');
  }
}
